import { createAction } from 'typesafe-actions';

export const userIsIdle = createAction('USER_IS_IDLE')();
export const userIsActive = createAction('USER_IS_ACTIVE')();
